import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DataLoader from '../components/DataLoader';
import {
  Frequencies, SubscriptionStatuses,
  endOfMonth, lookupFrequency, lookupStatus, startOfMonth,
} from '../helpers/constants';
import AlacrityTable from '../components/AlacrityTable';
import URL from '../helpers/url';
import { getUnsubscribe } from '../api/fetchApi';
import { resetUnsubscribe } from '../actions/resetAction';
import { AlacrityDropdown } from '../components/AlacrityDropdown';
import JsonApi from '../helpers/json_api.js';
import DateRangeFilter from '../components/DateRangeFilter';
import { settingDarkTable } from '../helpers/translations/cssClassHelper';
import {
  clearLS, getLS, removeLS, setLS,
} from '../helpers/utils';

class Subscription extends AlacrityTable {
  constructor(props) {
    super(props);

    this.filters = { filter: { created_at: { gte: startOfMonth, lte: endOfMonth } } };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.createProcessingEditor = this.createProcessingEditor.bind(this);
    this.msisdn = getLS('msisdn');

    this.state = {
      disabled: false,
      currentFilter: this.filters,
      isCancelled: false,
      changeTheme: null,
      resetUnsubState: null,
    };

    this.cancelled = false;
    this.columns = [
      {
        path: 'id', title: 'ID', isKey: true, filter: { type: 'TextFilter' }, hidden: true,
      },
      {
        path: 'created_at', title: 'created-at', sort: true, dataType: 'date', width: '25%',
      },
      { path: 'company_name', title: 'merchant' },
      { path: 'campaign_name', title: 'service' },
      { path: 'f_status', title: 'status', dataFormat: 'subscription_status' },
      { path: 'f_frequency', title: 'frequency' },
      {
        title: 'action',
        dataFormat: 'button',
        apiURL: '/admin/subscriptions/',
        handleSubmit: this.handleSubmit,
        disabled: this.state.disabled,
        customEditor: {
          getElement: this.createProcessingEditor.bind(this),
          customEditorParameters: { messageText: 'campaign_name', handleSubmit: this.handleSubmit.bind(this), iLang: this.props.i18n.language },
        },
        width: '12%',
        messageText: 'campaign_name',
      },
    ];
  }

  async handleSubmit(val, serviceName) {
    this.setState({ disabled: true });
    const data = { id: val };

    const isConfirm = await swal({
      title: this.props.t('Unsubscribe to ') + serviceName + this.props.t('?'),
      text: '',
      icon: 'warning',
      dangerMode: true,
      buttons: true,
    });

    if (isConfirm) {
      this.props.getUnsubscribe(data);
    } else {
      const cancelData = { id: val };
      this.props.resetUnsubscribe(cancelData);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetUnsubState && !_.isEmpty(nextProps.resetUnsubState)) {
      swal(this.props.t('Done!'), this.props.t('Your service have been unsubscribe!'), 'success');
      this.props.resetUnsubscribe(nextProps.resetUnsubState.id);
    }

    if (nextProps.changeTheme) {
      this.setState({ changeTheme: nextProps.changeTheme });
    }
  }

  filterHandler(from, to, attribute) {
    const _this = this;
    const fromComparator = JsonApi.normlizeComparator('>=');
    const toComparator = JsonApi.normlizeComparator('<=');
    const fromValue = from;
    const toValue = to;
    const filterValue = {};
    filterValue[fromComparator] = fromValue;
    filterValue[toComparator] = toValue;
    const filterObj = {};
    filterObj[attribute] = filterValue;

    const staticFilters = this.state.currentFilter ? ({ ...this.state.currentFilter.filter }) : {};
    const newFilters = { ...staticFilters, ...filterObj };
    _this.setState({ currentFilter: newFilters });
  }

  onChangeHandler(val, attribute) {
    const _this = this;
    const filterObj = {};

    filterObj[attribute] = { value: val, type: 'SelectFilter' };
    const staticFilters = this.state.currentFilter ? ({ ...this.state.currentFilter.filter }) : {};
    const newFilters = { ...staticFilters, ...filterObj };
    _this.setState({ currentFilter: newFilters });
  }

  render() {
    const { i18n, t, width } = this.props;
    let options; let optionsFrequency = [];

    if (this.props.i18n.language != 'undefined') {
      const x = lookupStatus.filter((o, index) => {
        if (o.key === this.props.i18n.language) {
          options = lookupStatus[index].value;
        }
      });
      const y = lookupFrequency.filter((o, index) => {
        if (o.key === this.props.i18n.language) {
          optionsFrequency = lookupFrequency[index].value;
        }
      });
    } else {
      options = SubscriptionStatuses;
      optionsFrequency = Frequencies;
    }

    return (
      <>
        <Header mainLayout width={width} />
        <div className="container-fluid">
          <br />
          {width <= 600 && (
            <h5>
              <b>
                {t('subscription')}
                {' '}
                -
                {' '}
                {this.msisdn}
              </b>
            </h5>
          )}
          {width > 600 && (
            <h3>
              {t('subscription')}
              {' '}
              -
              {' '}
              {this.msisdn}
            </h3>
          )}
          {width <= 600 && (
            <p className="small">{t('list-of-subscription')}</p>
          )}
          {width > 600 && (
            <p>{t('list-of-subscription')}</p>
          )}
          <hr className="style1" />
          <br />
          <div className={width < 600 ? 'row form-group' : 'row form-group justify-content-md-left'}>
            <div className={width < 600 ? 'col-sm-4' : 'col-sm-4 mr-1 pr-1'}>
              <div className="form-group">
                <div className={getLS('dark') == 'true' || this.state.changeTheme == 'true' ? 'filter text-filter form-control form-control-dark' : 'filter text-filter form-control'}>

                  {' '}
                  <DateRangeFilter
                    from={this.startDate}
                    to={this.endDate}
                    onDateRangeChange={this.filterHandler.bind(this)}
                    filterAttribute="created_at"
                    locale={this.props.i18n.language}
                  />
                </div>
              </div>
            </div>
            <div className={width < 600 ? 'col-sm-2' : width === 600 ? 'col-sm-3 ml-0 pl-0 mr-1 pr-1' : 'col-sm-2 ml-0 pl-0 mr-1 pr-1'}>
              <AlacrityDropdown
                t={t}
                iLang={this.props.i18n.language}
                options={options}
                title={t('dropdown.status')}
                onChange={this.onChangeHandler.bind(this)}
                filterAttribute="f_status"
              />
            </div>
            <div className={width < 600 ? 'col-sm-2' : width === 600 ? 'col-sm-3 ml-0 pl-0 mr-1 pr-1' : 'col-sm-2 ml-0 pl-0 mr-1 pr-1'}>
              <AlacrityDropdown
                t={t}
                iLang={this.props.i18n.language}
                options={optionsFrequency}
                title={t('dropdown.frequency')}
                onChange={this.onChangeHandler.bind(this)}
                filterAttribute="f_frequency"

              />
            </div>
          </div>
        </div>
        {/* Main table layout */}
        <div id="wrapper">
          <div id="main" className="container-fluid">
            <div>
              <DataLoader
                id="Subscription"
                apiUrl="/subscriptions"
                columns={this.columns}
                apiParams={this.state.currentFilter}
                unsubscribe={this.props.unsubscribe}
                changeTheme={this.props.changeTheme}
              />
            </div>
          </div>

        </div>
        <Footer className="footer-position" />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  unsubscribe: state.unsubs.unsubscribe,
  changeTheme: state.auth.changeTheme,
  resetUnsubState: state.unsubs.resetUnsubState,
});

const mapDispatchToProps = (dispatch) => ({
  getUnsubscribe: (data) => dispatch(getUnsubscribe(data)),
  resetUnsubscribe: (data) => dispatch(resetUnsubscribe(data)),
});

export default withTranslation('lang')(withRouter(connect(mapStateToProps, mapDispatchToProps)(Subscription)));
